import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { isActeNatureOperation, NatureOperationId } from '@lib/models/graphqlData';
import { ConseilConfigService, ValidityStatus } from 'src/app/services/conseil-config.service';
import { FicheConseilService } from 'src/app/services/fiche-conseil.service';

@Component({
  selector: 'app-deprecation-warning-dialog',
  templateUrl: './deprecation-warning-dialog.component.html',
  styleUrls: ['./deprecation-warning-dialog.component.scss'],
})
export class DeprecationWarningDialogComponent {
  expirationDate: string | null;
  isCreatingNewFiche = false;
  validityStatus: ValidityStatus | null = null;
  constructor(
    private conseilConfigService: ConseilConfigService,
    private ficheConseilService: FicheConseilService,
    private router: Router,
    private dialog: MatDialogRef<DeprecationWarningDialogComponent>,
    private datePipe: DatePipe
  ) {}
  ngOnInit(): void {
    this.validityStatus = this.conseilConfigService.getValidityStatus();
    this.expirationDate = this.datePipe.transform(
      this.conseilConfigService.currentConseilConfigSubject.value?.validityLimitDate,
      'dd/MM/yyyy'
    );
  }
  async onCreateNewOne() {
    this.isCreatingNewFiche = true;
    const newFicheId = await this.ficheConseilService.createFicheFromCurrentFiche();
    const newNatureOperationId = this.ficheConseilService.currentFicheConseilSubject.value?.natureOperation?.id;
    const route = newNatureOperationId === NatureOperationId.Souscription || !isActeNatureOperation(newNatureOperationId)
      ? 'fiche'
      : 'acte';
    this.router.navigate([route, newFicheId]);
    this.isCreatingNewFiche = false;
    this.dialog.close();
  }
}
